module.exports = __webpack_public_path__ + "img/noAdjustSYJ.819efd8c.png";